const { lazy } = require('react')

export const RequestPageAsync = lazy(() => import('./RequestPage'))
